import { State } from "./state";

export const getAccountServiceOpenstackRequests = (state: State) => {
  return state.accountservice?.ACCOUNT_SERVICE_LIST?.openstack?.requests;
};
